module.exports = __webpack_public_path__ + "static/25c107c1dfed089ba52655cd63387742b72feb82627598c457c4bd30174829f8-8f21128f5ebe034dbc360cf0fe4b52ca.png";